import React, { useMemo } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import Sort from '../../../../../components/Sort';

const useStyles = makeStyles(() => ({
  sortButton: {
    width: '1.5rem',
    height: '1.5rem',
    marginLeft: '0.5rem',
    borderRadius: '12px',
    backgroundColor: '#f5faff',
  },
}));

const SortBtn = ({ sort, handleSort, label }) => {
  const classes = useStyles();

  const sortKey = useMemo(() => {
    switch (label) {
      case 'A.D.T':
        return 'A.D.T';
      case 'WT.':
        return 'WT.';
      case 'Specialty':
        return 'SPECIALTY';
      case 'Priority':
        return 'PRIORITY';
      case 'Status':
        return 'STATUS';
      case 'HANdling by':
        return 'HANDLING BY';
      default:
        return '';
    }
  }, [label]);

  return (
    sortKey && (
      <ButtonBase className={classes.sortButton} onClick={handleSort(sortKey)}>
        <Sort sort={sort} sortKey={sortKey} />
      </ButtonBase>
    )
  );
};

const headerRenderer =
  (sort, handleSort) =>
  ({ label }) => {
    return (
      <Box display="flex" alignItems="center" flexWrap="nowrap">
        {label}
        <SortBtn sort={sort} handleSort={handleSort} label={label} />
      </Box>
    );
  };

export default headerRenderer;
